import { useQueryClient } from "@tanstack/react-query";
import { addListing } from "../../api";
import { AddListingDTO } from "../../dtos";
import { Listing } from "../../types";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useAddListing() {
  const queryClient = useQueryClient();

  const mutationAddListing = useDomainMutation<
    AxiosResponse<Listing>,
    { response?: { data?: { message?: string } } },
    AddListingDTO
  >({
    mutationFn: (data: AddListingDTO) => addListing(data),
    onSuccess: (_, data) => {
      queryClient.invalidateQueries({ queryKey: ["listings"] });
      if (data.property) queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationAddListing;
}
